import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Row, SearchData } from '@shared/interfaces/CallLog';

enum idvStatusMap {
  Uncomplete = 'Not Completed',
  NA = 'Unauthorised',
  Passed = 'Passed',
  Failed = 'Failed',
  Refused = 'Refused',
}

interface generalData {
  generalFormData: Row;
  isTransferred: boolean;
  isUnauthorised: boolean;
  isAgentCalling?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  constructor() {}

  createGeneralForm(data: generalData): FormGroup {
    const generalFormData = data.generalFormData;
    const idvStatus = generalFormData.idvStatus?.value || '';

    const generalForm = new FormGroup({
      direction: new FormControl(generalFormData.callType?.value ?? null),
      id_v: new FormControl(
        this.getIdvStatus(idvStatus, data.isTransferred, data.isUnauthorised)
      ),
      vulnerability: new FormControl(
        generalFormData.vulnerability?.value ?? 'NA'
      ),
      category: new FormControl(generalFormData.category?.value ?? null),
      callFromTo: new FormControl(
        this.getCallFromTo(
          idvStatus,
          data?.isUnauthorised,
          generalFormData.callFromTo?.value
        )
      ),
      successfulContact: new FormControl(
        this.getSuccessfulContact(
          data?.isAgentCalling,
          generalFormData.successfulContact?.value
        )
      ),
      accountNumber: new FormControl(
        (generalFormData.entityId?.value?.accountRef ||
          generalFormData.entityId?.value?.AccountRef) ??
          null
      ),
      relationship: new FormControl(
        generalFormData.relationship?.value ?? null
      ),
      linkedAccount: new FormControl(
        generalFormData.linkedAccounts?.value ?? null
      ),
      callClosure: new FormControl(generalFormData.callClosure?.value ?? null),
    });

    return generalForm;
  }

  filterSearchData(searchData: SearchData): boolean {
    return (
      !!searchData &&
      !!searchData.General &&
      !!searchData.General.data &&
      !!searchData.General.data.rows &&
      !!searchData.General.data.rows[0]
    );
  }

  private getIdvStatus(
    idvStatus: string,
    isTransferred: boolean,
    isUnauthorised: boolean
  ): string {
    let idvStatusMapped = this.idVStatusConditionalsMapper({
      idvStatus: idvStatus,
      isTransferred: isTransferred,
      isUnauthorised: isUnauthorised,
    });

    return idvStatusMap[idvStatusMapped];
  }

  private idVStatusConditionalsMapper(data): string {
    let value = data.idvStatus;
    if (data.isTransferred) value = 'Passed';
    if (data.isUnauthorised) value = 'NA';
    return value;
  }

  private getCallFromTo(
    idvStatus: string,
    isUnauthorised: boolean,
    callFromToValue?: string
  ): string {
    return isUnauthorised || idvStatus === 'NA'
      ? 'Unauthorised Caller'
      : callFromToValue ?? '';
  }

  private getSuccessfulContact(
    isAgentCalling: boolean,
    successfulContactValue?: boolean
  ): string {
    return isAgentCalling ? '' : successfulContactValue ? 'Yes' : 'No';
  }
}
